import { render, staticRenderFns } from "./transaction-log-record.vue?vue&type=template&id=c5873d0e&scoped=true&"
import script from "./transaction-log-record.vue?vue&type=script&lang=js&"
export * from "./transaction-log-record.vue?vue&type=script&lang=js&"
import style0 from "./transaction-log-record.vue?vue&type=style&index=0&id=c5873d0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5873d0e",
  null
  
)

export default component.exports